// extracted by mini-css-extract-plugin
module.exports = {"container_img":"tohome_container_img__3fOQ5","img":"tohome_img__1Nk1V","link":"tohome_link__2aMWA","pres":"tohome_pres__2D7Kt"};